import {
  useRemoteVideoTileState,
  useRosterState,
} from 'amazon-chime-sdk-component-library-react'

export const useVideoTiles = () => {
  const { roster } = useRosterState()
  const { tiles, tileIdToAttendeeId } = useRemoteVideoTileState()

  return tiles
    .map(tileId => {
      const attendee = roster[tileIdToAttendeeId[tileId]] ?? undefined
      if (attendee?.externalUserId?.includes('camera')) {
        const name = attendee.externalUserId.split('#')[1]
        return { id: tileId, name }
      } else {
        return undefined
      }
    })
    .filter(tileId => tileId !== undefined)
    .sort((a, b) => a.name.localeCompare(b.name))
}
